var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueshift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 293.1 211.9",
    style: {
      enableBackground: "new 0 0 293.1 211.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0 {\n            fill: #2A5E8E;\n        }\n\n        .st1 {\n            fill: #0384B4;\n        }\n\n        .st2 {\n            fill: #61C1ED;\n        }\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.5,0c-4.9,0.2-9.8,0.7-14.8,0.6c-8.1-0.1-16.2-0.4-24.2-0.6C149.5,0,162.5,0,175.5,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.8,93.4c0-8.7-0.2-17.1,0.2-25.4c0.1-1.9,1.7-4.3,3.4-5.4c8.4-5.7,17.6-8.7,27.9-8.9 c14.7-0.3,28.2,2.6,39.6,12.5c13.8,12.1,20.5,27.8,23.2,45.5c2.7,17.3,2.3,34.5-2.8,51.4C272,184,260.6,201,239,208.4 c-16.4,5.6-32.9,5.7-48.6-3.2c-2.5-1.4-3.8-3.1-3.7-6.3c0.2-8.7,0.1-17.5,0.1-27.1c9.2,7.8,18.5,10.3,29.3,7.6 c6.6-1.6,11.7-5.2,15.8-10.3c7.5-9.4,10.9-20.3,10.9-32.4c0-9.7-0.2-19.2-3.8-28.5C230.9,87,206.9,79.7,188.3,93 C188.1,93.1,187.7,93.1,186.8,93.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.9,2.6c13,0,25.4,0,38.6,0c-0.2,68.4,0.2,136.5-0.2,205.3c-13,0-24.4,0.1-35.9-0.1c-0.8,0-2.2-2.1-2.2-3.3 c-0.1-65.1,0-130.3,0-195.4C137.2,7.1,137.1,5.1,136.9,2.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.2,50.1c12.6,0,24.7,0,37.1,0c0,3,0,5.7,0,8.5c0,47.7-0.1,95.3,0.1,143c0,4.8-1.3,6.4-6.2,6.2 c-9-0.4-18-0.2-27-0.1c-3.1,0-4.5-0.7-4.5-4.2c0.1-50.3,0.1-100.6,0.1-151C73.8,51.9,74,51.2,74.2,50.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,95.8c12.6,0,24.7,0,37.1,0c0,2.1,0,4.1,0,6c0,33.8-0.1,67.7,0.1,101.5c0,3.4-1.3,4.5-6.2,4.4 c-9-0.3-18-0.1-27,0c-3.1,0-4.5-0.5-4.5-3C7.6,169,7.6,133.2,7.6,97.5C7.6,97.1,7.8,96.6,8,95.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueshift);
export default __webpack_public_path__ + "static/media/blueshift.d6bdab5ca3d074b1fc3f669885d90923.svg";
export { ForwardRef as ReactComponent };